import type { LoaderFunctionArgs } from 'react-router-dom'

import type { Device } from '@/api/definition'
import { DefaultFetchDeviceFilters, DurationTestStatus } from '@/api/definition'
import { fetchDevicePageApi } from '@/api/devicePageApi'

// Define your loader data interface
export interface IntakeLoaderData {
  initialDevices: Device[]
  rowCount: number
  error?: string
}

// Create the loader function
export async function intakeLoader(
  _args: LoaderFunctionArgs,
): Promise<IntakeLoaderData> {
  try {
    //cannot use hooks in loader since it is not a react component
    // Fetch just the first page with default filters
    const result = await fetchDevicePageApi(
      {
        ...DefaultFetchDeviceFilters,
        inService: false,
        durationTestStatus: [DurationTestStatus.DurationTestNotStarted],
      },
      {
        pageIndex: 0,
        pageSize: 10,
        sortBy: [],
        globalFilter: '',
        selectedFilters: {},
      },
      false,
    )
    // Transform data to match your component's expectations
    const transformedData = result.data?.length
      ? result.data.map((device) => ({
          ...device,
          id: device.uid,
        }))
      : []

    return {
      initialDevices: transformedData,
      rowCount: result.rowCount ?? 0,
    }
  } catch (error) {
    console.error('Failed to load initial device data:', error)
    return {
      initialDevices: [],
      rowCount: 0,
      error: 'Failed to load initial device data',
    }
  }
}
